import React from 'react';
import { Link } from 'react-router-dom';
import './Advantages.css';

export interface Props {
  title: string
  img1: string
  img2: string | null
  img3: string | null
  text1: string
  text2: string | null
  text3: string | null
  color?: string
}

function Advantages(props : Props) {
  return (
    <div className="Advantages" style={{background: `${props.color? props.color : 'white'}`}}>
        <div className='left'>
            <svg width="229" height="37" viewBox="0 0 229 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M227.768 20.2677C228.744 19.2914 228.744 17.7085 227.768 16.7322L211.858 0.822306C210.882 -0.154004 209.299 -0.154004 208.322 0.822306C207.346 1.79862 207.346 3.38153 208.322 4.35784L222.464 18.5L208.322 32.6421C207.346 33.6184 207.346 35.2013 208.322 36.1776C209.299 37.154 210.882 37.154 211.858 36.1776L227.768 20.2677ZM-9.42408e-05 21L226 21L226 16L-9.424e-05 16L-9.42408e-05 21Z" fill="url(#paint0_linear_18_1897)"/>
                <defs>
                <linearGradient id="paint0_linear_18_1897" x1="97.0027" y1="-6.50668" x2="237.003" y2="50.9919" gradientUnits="userSpaceOnUse">
                <stop offset="0.168324" stopColor="#11828A"/>
                <stop offset="1" stopColor="#3AAC92"/>
                </linearGradient>
                </defs>
            </svg>
            <span className='align-left'>{props.title}</span>
        </div>
        <div className='right'>
            <div>
                <img src={props.img1}/>
                <span>{props.text1}</span>
            </div>
            {props.img2 && props.text2 ?
                <div>
                    <img src={props.img2}/>
                    <span>{props.text2}</span>
                </div>
            : null }
            {props.img3 && props.text3 ?
                <div>
                    <img src={props.img3}/>
                    <span>{props.text3}</span>
                </div>
            : null }
        </div>
    </div>
  );
}

export default Advantages;
